import { rem } from "@certn/cascadia/utils";
import { CascadiaSpacing } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import classNames from "classnames";
import { useSeparator } from "react-aria";

import { useColors } from "../../hooks/useColors";

export interface DividerProps {
  inset?: boolean | CascadiaSpacing;
  marginVertical?: CascadiaSpacing;
  marginHorizontal?: CascadiaSpacing;
  marginTop?: CascadiaSpacing;
  marginBottom?: CascadiaSpacing;
  className?: string;
  isVertical?: boolean;
  testID?: string;
  borderLeftColor?: string;
  hideBorder?: boolean;
}

export function Divider(props: DividerProps) {
  const {
    className,
    testID = "divider",
    inset,
    marginVertical,
    marginHorizontal,
    marginTop,
    marginBottom,
    isVertical,
    borderLeftColor,
    hideBorder,
  } = props;
  const { separatorProps } = useSeparator({});
  const colors = useColors();
  const border = hideBorder
    ? "1px transparent"
    : `1px solid ${borderLeftColor ? borderLeftColor : "var(--border-base)"}`;

  return (
    <hr
      aria-hidden
      data-testid={testID}
      className={classNames(
        css(
          {
            border: `0 solid ${colors["border-base"]}`,
            margin: 0,
          },
          inset && {
            marginLeft: inset === true ? "var(--space-5)" : rem(inset),
            marginRight: inset === true ? "var(--space-5)" : rem(inset),
          },
          marginVertical && {
            marginTop: rem(marginVertical),
            marginBottom: rem(marginVertical),
          },
          marginHorizontal && {
            marginLeft: rem(marginHorizontal),
            marginRight: rem(marginHorizontal),
          },
          marginTop && {
            marginTop: rem(marginTop),
          },
          marginBottom && {
            marginBottom: rem(marginBottom),
          },
          {
            borderTop: !isVertical ? border : undefined,
            height: isVertical ? "inherit" : undefined,
            borderLeft: isVertical ? border : undefined,
          }
        ),
        className
      )}
      {...separatorProps}
    />
  );
}
